module.exports = __webpack_public_path__ + "img/dongji_ps_14.c2713bf1.jpg";